// src/store/reducers/lastRouteReducer.js

import { SET_LAST_ROUTE, CLEAR_LAST_ROUTE } from "./actions";

const initialState = {
  lastRoute: null,
};

const lastRouteReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case SET_LAST_ROUTE:
      return {
        ...state,
        lastRoute: action.payload,
      };
    case CLEAR_LAST_ROUTE:
      return {
        ...state,
        lastRoute: null,
      };
    default:
      return state;
  }
};

export default lastRouteReducer;
